import {PersonLogin} from '../person/person-login';

export class TaskResponse {

  taskId!: number;
  responder!: PersonLogin;
  additionalData!: string;
  approved!: boolean;

}
